import i18n from "src/locales/i18n";

export const getBulkImportErrorMessage = (e: any): string => {

  if (e?.status === 403) {
    return i18n.t('exceptions.unauthorized');
  }

  return i18n.t('contacts.bulk_import_modal.errors.import_failed');
};